/***
 * 会员关怀接口-物流广告配置对接部分
 */
import { post, postJson, imagePost } from '../axios'

const RESOURCE_BASE_PATH = '/logisticsAdvertiseController'

/***
 * 物流广告列表表格
 * @param p
 */
export const getLogisticsAdvertiseConfigList = p => postJson(`${RESOURCE_BASE_PATH}/getLogisticsAdvertiseConfigList`, p)

/***
 * 测试发送短信
 * @param p
 * @returns {*}
 */
export const logisticsAdvertiseSendMsg = p => postJson(`${RESOURCE_BASE_PATH}/logisticsAdvertiseSendMsg`, p)

/***
 * 删除物流广告
 * @param p
 */
export const deleteLogisticsAdvertiseConfig = p => post(`${RESOURCE_BASE_PATH}/deleteLogisticsAdvertiseConfig`, p)

/***
 * 添加物流广告
 * @param p
 */
export const addLogisticsAdvertiseConfig = p => postJson(`${RESOURCE_BASE_PATH}/addLogisticsAdvertiseConfig`, p)

/***
 * 上传banner图片
 * @param p
 */
export const uploadBannerUrl = p => imagePost(`${RESOURCE_BASE_PATH}/uploadBannerUrl`, p)

/**
 *  计算物流广告点击数
 * @param p
 */
export const calculateLogisticsLinkClicks = p => post(`${RESOURCE_BASE_PATH}/calculateLogisticsLinkClicks`, p)

/**
 *  编辑显示物流信息
 * @param p
 */
export const getLogisticsAdvertiseConfigDetail = p => post(`${RESOURCE_BASE_PATH}/getLogisticsAdvertiseConfigDetail`, p)

/**
 *  物流链接跳转页面
 * @param p
 */
export const logisticsAdvertiseLinkPage = p => post(`${RESOURCE_BASE_PATH}/logisticsAdvertiseLinkPage`, p)

/**
 *  物流广告 数据显示号码
 * @param p
 */
export const logisticsAdvertiseSecondSend = p => post(`${RESOURCE_BASE_PATH}/logisticsAdvertiseSecondSend`, p)
/**
 *  物流广告 数据显示号码
 * @param p
 */
export const logisticsAdvertiseSecondSendNum = p => postJson(`${RESOURCE_BASE_PATH}/logisticsAdvertiseSecondSend`, p)

/**
 *  物流广告 活动效果
 * @param p
 */
export const logisticsAdvertisingActivityEffect = p => postJson(`${RESOURCE_BASE_PATH}/logisticsAdvertisingActivityEffect`, p)

/**
 *  更新物流广告消息
 * @param p
 */
export const updateLogisticsAdvertiseConfig = p => postJson(`${RESOURCE_BASE_PATH}/updateLogisticsAdvertiseConfig`, p)

/**
 * 上传文件路径
 */
export const logisticsImagesUrl = () => {return `${RESOURCE_BASE_PATH}/images/logistics/`};